<template>    
    <v-card color="#fff">
        <v-card-title>            
            <h1 class="display-5">{{ item.name }}</h1> </br>                
        </v-card-title>                                        
        <v-container grid-list-xs fill-height>
            <v-layout row wrap fill-height>
                <v-flex xs6>                    
                    <v-layout column>
                        <v-flex >
                            <p v-if="item.number">
                                <b>{{item.number}}</b>                                                                              
                            </p>
                            <p v-else>
                                &nbsp;
                            </p>
                        </v-flex>
                        <v-flex >
                            <p v-if="item.description">
                                <small>{{item.description}}</small>
                            </p>
                            <p v-else>
                                &nbsp;
                            </p>
                        </v-flex>
                        <v-flex>
                            <p v-if="item.started_at">
                                <v-icon>event_available</v-icon> {{ formatDate(item.started_at)}}
                            </p>      
                            <p v-if="item.ended_at">
                                <v-icon>event_busy</v-icon> {{ formatDate(item.ended_at)}}
                            </p>     
                        </v-flex>
                    </v-layout>              
                </v-flex>
                <v-flex d-flex xs2></v-flex>
                <v-flex d-flex xs4>
                    
                </v-flex>
            </v-layout>
        </v-container>

                        
        <v-card-actions class="grey darken-3 pt-0">
            
            <listactionbar v-on:actiontriggered="onAction" :item="item" :tileactions="tileactions"></listactionbar>
            
        </v-card-actions>  
                    
        
    </v-card>
</template>
<script>
    import listactionbar from './ListActionbar.vue'
    import { mapGetters } from 'vuex';    
    export default {   
    
    props: [
        'item',
        'tileactions',
        'paths'
    ],
    components: {
        listactionbar:listactionbar
    },
    data() {
        return {  
           
                    
        }
    },
    computed: {
        
        
    },
    methods: {
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = new Date(date).toISOString().substr(0,10).split('-')
            return `${day}/${month}/${year}`
        },
        onAction(action){
            
            if(action.link!=""){
                this.$router.push({name: action.link, params: {id: this.item.id}})
            } else {
                var r = confirm("remove image")
                if (r == true) {                
                    this.$store.dispatch('projects/deleteById',this.item.id)
                            .then(response=>{
                                this.setMessage('200','Erfolg. Das Projekt wurde gelöscht')
                            }).catch(error=>{
                                this.setMessage(error.response.status,error.response.data)
                            })
                }else{                    
                }
            }
        }
    },
    
    
    
}
</script>
